import React from 'react'
import classes from './CircleLoader.module.less'

export type CircleLoaderProps = {
    /**
     * default 40px
     */
    size?: number
    className?: string
}

export const CircleLoader: React.FC<CircleLoaderProps> = (props: CircleLoaderProps) => {
    return (
        <div
            style={{ height: props.size ?? 40, width: props.size ?? 40 }}
            className={`${classes['circle-loader']} ${props.className ?? ''}`}
            data-testid="circle-loader-wrapper"
        ></div>
    )
}
